import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  CorrectionsForm,
} from 'Views/Page/Content/Modal/Layouts/JobEmployerMatchWrongAccountTypeStep/Layout/CorrectionsForm';

export default buildFacetDesignOverride()
  .nameOverride('corrections', { _component: () => CorrectionsForm }, overrideReadOnly);
